import { render, staticRenderFns } from "./PlansLayout.vue?vue&type=template&id=35d9961c&scoped=true"
import script from "./PlansLayout.vue?vue&type=script&lang=js"
export * from "./PlansLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9961c",
  null
  
)

export default component.exports